import { LinkageState, UserProfile } from '../types/user';

export interface EffectiveLinkageState {
  org: LinkageState;
  team: LinkageState;
  hasAnyLinkedAccess: boolean;
  hasSufficientAccess: boolean; // Role-aware: org admins only need org access
}

function deriveOrgState(profile: UserProfile): LinkageState {
  if (profile.org_link_state) return profile.org_link_state;
  const hasOrgMembership = !!profile.organization_id || !!profile.organization_memberships?.length;
  return hasOrgMembership ? 'linked' : 'unlinked';
}

function deriveTeamState(profile: UserProfile): LinkageState {
  if (profile.team_link_state) return profile.team_link_state;
  const hasTeamMembership = !!profile.team_ids?.length;
  return hasTeamMembership ? 'linked' : 'unlinked';
}

export function getEffectiveLinkageState(profile: UserProfile | null | undefined): EffectiveLinkageState {
  if (!profile) {
    return {
      org: 'unlinked',
      team: 'unlinked',
      hasAnyLinkedAccess: false,
      hasSufficientAccess: false,
    };
  }

  const org = deriveOrgState(profile);
  const team = deriveTeamState(profile);
  const hasAnyLinkedAccess = org === 'linked' || team === 'linked';

  // School admins only need org access, not team access
  const isOrgAdmin = profile.role === 'school_admin';
  const hasSufficientAccess = isOrgAdmin
    ? org === 'linked'
    : hasAnyLinkedAccess;

  return {
    org,
    team,
    hasAnyLinkedAccess,
    hasSufficientAccess,
  };
}

